import { useContext } from 'react';
import { CacheContext } from './context';

export const useCache = () => {
  return useContext(CacheContext);
};

// Specific hooks for individual cached resources
export const useOutletsCache = () => {
  const { outlets, getOutletById } = useContext(CacheContext);
  return { outlets, getOutletById };
}; 